import axios from 'axios';
import { getToken } from '@/utils/auth';

// 创建axios实例
const service = axios.create({
  baseURL: '/', // api的base_url
  timeout: process.env.VUE_APP_AXIOS_TIMEOUT, // 请求超时时间,
  withCredentials: process.env.NODE_ENV === 'development',
  headers: {
    'Cache-Control': 'no-store',
    'Pragma': 'no-cache'
  }
});

/**
 * request拦截器
 */
service.interceptors.request.use(config => {
  config.headers['authorization'] = getToken();
  return config;
}, error => {
  Promise.reject(error);
});

/**
 * respone拦截器
 */
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 401) {
      return Promise.reject('error');
    } else if (res.code === 422) {
      const keys = Object.keys(res.data)
      const errData = res.data[keys[0]] || [res.message]
      res.message = errData[0]
      return Promise.resolve(res);
    } else {
      return Promise.resolve(res);
    }
  },
  error => {
    if (error.response && error.response.data && error.response.data.message) {
      error.message = error.response.data.message
    }
    return Promise.reject(error);
  }
);

export default service;
